import React, { FormEvent, useEffect, useRef, useState } from 'react';
import { SetupMessage } from './useStoreSetupChat';

const SUGGESTIONS = ['Confirmation COD', 'Boutique simple'];

type Props = {
  messages: SetupMessage[];
  thinking: boolean;
  onSend: (text: string) => void;
};

const SetupTalk: React.FC<Props> = ({ messages, thinking, onSend }) => {
  const [draft, setDraft] = useState('');
  const logRef = useRef<HTMLDivElement>(null);
  const hasUser = messages.some((message) => message.role === 'user');

  useEffect(() => {
    const node = logRef.current;
    if (!node) return;
    node.scrollTop = node.scrollHeight;
  }, [messages, thinking]);

  const submit = (event?: FormEvent) => {
    event?.preventDefault();
    const text = draft.trim();
    if (!text) return;
    setDraft('');
    onSend(text);
  };

  return (
    <section className="store-setup__talk" aria-label="Discussion">
      <div className="store-setup__log" ref={logRef} aria-live="polite">
        {messages.map((message) => (
          <p
            key={message.id}
            className={`store-setup__bubble store-setup__bubble--${message.role}`}
          >
            {message.text}
          </p>
        ))}
        {thinking ? <p className="store-setup__bubble store-setup__bubble--assistant">Je prépare le setup</p> : null}
      </div>

      {!hasUser ? (
        <div className="store-setup__chips">
          {SUGGESTIONS.map((label) => (
            <button key={label} type="button" onClick={() => onSend(label)}>
              {label}
            </button>
          ))}
        </div>
      ) : null}

      <form className="store-setup__composer" onSubmit={submit}>
        <label className="store-setup__sr" htmlFor="setup-draft">Message</label>
        <textarea
          id="setup-draft"
          rows={2}
          value={draft}
          placeholder="Ex. ajoute un statut Échange"
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault();
              submit();
            }
          }}
        />
        <button type="submit" disabled={!draft.trim()}>
          Envoyer
        </button>
      </form>
    </section>
  );
};

export default SetupTalk;
